<template>
  <div class="countdown">
    <!-- {{data}} -->
    <v-col class="pt-5">
      <v-row class="justify-center">
        <v-col cols="12" sm="6" md="4" class="text-center">
          <div>
            <div class="text-h6 font-weight-bold">Pembayaran Berhasil</div>
          </div>
          <div class="pt-3">
            <div class="font-size-13 grey--text text--darken-1">Kode Transaksi</div>
            <div class="pt-1 text-body-1 font-weight-bold">{{ data.trx_code }}</div>
          </div>
          <div class="pt-3">
            <div class="font-size-13 grey--text text--darken-1">Kode Invoice</div>
            <div class="pt-1 text-body-1 font-weight-bold">{{ data.trx_midtrans_invoice }}</div>
          </div>
          <div class="pt-4">
            <img src="/assets/icons/payment-success.svg" />
          </div>
          <div class="pt-3">
            <div class="font-size-13 grey--text text--darken-1">Total Pembayaran</div>
            <div class="pt-1 text-body-1 font-weight-bold">{{ data.trx_bill | toRupiah }}</div>
          </div>
          <div class="pt-3" v-if="data.trx_payment_text">
            <img width="25%" :src="data.trx_payment_text.payment_image" />
            <div
              class="mt-n1 font-size-13 grey--text text--darken-1"
            >{{ data.trx_payment_text.payment_text }}</div>
          </div>
          <div class="mt-5">
            <v-row class="justify-center">
              <v-col md="8" class="py-0">
                <div>
                  <router-link :to="{name: 'transaction'}" class="text-deco">
                    <v-btn depressed height="45" block color="primary" class="rounded-lg" outlined>
                      <div class="font-weight-bold text-body-2">Lihat Transaksi</div>
                    </v-btn>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<script>
export default {
  props: {
    data: Object
  },
  methods: {
    downloadPDF(pdf) {
      window.open(pdf);
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Pembayaran");
    if (this.data.trx_status != "paid") {
      this.$router.push({ name: "transaction" });
    }
  }
};
</script>